(function () {
  var root = document.querySelector('[data-rsg-dock]');
  if (!root) return;

  var toggle = root.querySelector('[data-rsg-dock-toggle]');
  var panel = root.querySelector('#rsg-dock-panel');
  var toggleText = root.querySelector('[data-rsg-toggle-text]');
  var phoneLink = root.querySelector('[data-rsg-action="phone"]');
  var phoneLabel = root.querySelector('[data-rsg-phone-label]');
  var liveLabel = root.querySelector('[data-rsg-live-label]');
  var liveButton = root.querySelector('[data-rsg-action="livechat"]');
  var phoneTimer = 0;
  var PHONE = '813-647-6666';

  function shopIsOpen(date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date || new Date());
    var weekday = '';
    var hour = 0;
    var minute = 0;
    parts.forEach(function (part) {
      if (part.type === 'weekday') weekday = part.value;
      if (part.type === 'hour') hour = Number(part.value);
      if (part.type === 'minute') minute = Number(part.value);
    });
    if (['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(weekday) === -1) return false;
    var mins = hour * 60 + minute;
    return mins >= 9 * 60 && mins < 17 * 60;
  }

  function syncHours() {
    var open = shopIsOpen(new Date());
    root.classList.toggle('is-open-hours', open);
    root.classList.toggle('is-closed-hours', !open);
    if (liveLabel) liveLabel.textContent = open ? 'Live Chat' : 'Leave a message';
  }

  var DISMISS_KEY = 'rsg-dock-dismissed';

  function dockWasDismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function rememberDockClosed() {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (error) {}
  }

  function setOpen(open) {
    root.classList.toggle('is-open', open);
    if (panel) panel.hidden = !open;
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (toggleText) toggleText.textContent = open ? 'Close contact menu' : 'Open contact menu';
    if (!open) rememberDockClosed();
  }

  function legacyCopy(value) {
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (error) {
        reject(error);
      }
      field.remove();
    });
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value).catch(function () {
        return legacyCopy(value);
      });
    }
    return legacyCopy(value);
  }

  function inboxRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('shopify-chat, inbox-online-store-chat, #shopify-chat, #ShopifyChat'));
  }

  function clickable(node) {
    if (!node) return null;
    if (node.shadowRoot) {
      var inner = node.shadowRoot.querySelector('button, [role="button"]');
      if (inner) return inner;
    }
    if (node.matches && node.matches('button, [role="button"], iframe')) return node;
    return node.querySelector ? node.querySelector('button, [role="button"]') : null;
  }

  function hideLaunchers() {
    var host = document.querySelector('shopify-chat');
    if (!host) return;
    walkShadows(host, function (root) {
      root.querySelectorAll('button').forEach(function (button) {
        var label = (button.innerText || button.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
        if (label !== 'Chat' && button.getAttribute('part') !== 'activator') return;
        button.setAttribute('data-rsg-inbox-launcher', 'hidden');
        button.style.setProperty('display', 'none', 'important');
      });
    }, 0);
  }

  function openInbox() {
    var opened = false;
    var host = document.querySelector('shopify-chat');
    if (host) {
      if (typeof host.show === 'function') {
        host.show();
        return true;
      }
      if (typeof host.open === 'function') {
        host.open();
        return true;
      }
      walkShadows(host, function (root) {
        if (opened) return;
        root.querySelectorAll('button').forEach(function (button) {
          if (opened) return;
          var label = (button.innerText || button.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
          if (label !== 'Chat' && button.getAttribute('part') !== 'activator') return;
          button.style.setProperty('display', 'none', 'important');
          button.click();
          opened = true;
        });
      }, 0);
    }
    if (!opened && window.Shopify && window.Shopify.chat && typeof window.Shopify.chat.open === 'function') {
      window.Shopify.chat.open();
      opened = true;
    }
    return opened;
  }

  function walkShadows(node, visit, depth) {
    if (!node || depth > 8) return;
    var root = node.shadowRoot;
    if (!root) return;
    visit(root);
    root.querySelectorAll('*').forEach(function (el) {
      walkShadows(el, visit, depth + 1);
    });
  }

  function tidyChat() {
    var host = document.querySelector('shopify-chat');
    if (!host) return;
    walkShadows(host, function (root) {
      root.querySelectorAll('button, a').forEach(function (el) {
        var label = (el.innerText || el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
        if (label === 'Sign in') {
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('hidden', '');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    }, 0);
  }

  function watchInbox() {
    function sweep() {
      hideLaunchers();
      tidyChat();
      var host = document.querySelector('shopify-chat');
      if (!host) return;
      var expanded = false;
      walkShadows(host, function (root) {
        if (root.querySelector('.panel--size-expanded')) expanded = true;
      }, 0);
      host.classList.toggle('is-expanded', expanded);
      walkShadows(host, function (root) {
        if (root.__rsgWatch) return;
        root.__rsgWatch = true;
        new MutationObserver(sweep).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }, 0);
    }
    sweep();
    new MutationObserver(sweep).observe(document.documentElement, { childList: true, subtree: true });
    window.setInterval(sweep, 1000);
  }

  if (toggle) {
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(!root.classList.contains('is-open'));
    });
  }

  if (phoneLink) {
    phoneLink.addEventListener('click', function (event) {
      var desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (!desktop) return;
      event.preventDefault();
      var original = phoneLabel ? phoneLabel.textContent : 'Call Us';
      copyText(PHONE).then(function () {
        if (!phoneLabel) return;
        phoneLabel.textContent = PHONE + ' copied';
        window.clearTimeout(phoneTimer);
        phoneTimer = window.setTimeout(function () {
          phoneLabel.textContent = original === PHONE + ' copied' ? 'Call Us' : original;
        }, 3500);
      });
    });
  }

  if (liveButton) {
    liveButton.addEventListener('click', function () {
      openInbox();
    });
  }

  syncHours();
  if (!dockWasDismissed()) setOpen(true);
  window.setInterval(syncHours, 60000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchInbox);
  } else {
    watchInbox();
  }

  window.RSGContactDock = { shopIsOpen: shopIsOpen };
})();
